import React from 'react';
import './style/App.scss';


import Header from './header';
import Banner from './banner';
import About from './about';
import Choose from './choose';
import Software from './software';
import Works from './works';
import Fleet from './fleet';
import Featured from './featured';
import Footer from './footer';
import OurTeam from './ourTeam';

function Home() {
    return (
      <div className="App">
       <Header />
       <Banner />
       <About />
       <Choose />
       <Software />
       <Works />
       <Fleet />
	     <OurTeam />
       <Featured />
       <Footer />
       </div>
  );
}

export default Home;